/**
 * Created by jimmy on 2022/7/1.
 */

import React, { useState, useEffect, useRef } from 'react';
import { Button, Image, Input, InputNumber, Form, Cascader, message, Space, Modal, Select, Tooltip, Table, Typography } from 'antd';
import { WarningOutlined, ZoomInOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import BraftEditor from 'braft-editor';
import 'braft-editor/dist/index.css';
import FilterPanel from "../../components/filter-panel";

import * as CONST from '../../common/const';
import * as REQUEST from "../../common/request";
import * as Utils from "../../common/utils";

import Page from '../../components/page';
import UploadPictureList from '../../components/uploadPictureList';
import './index.less';

const PageModel = props => {
  const [form] = Form.useForm();
  const [imageFileList, setImageFileList] = useState([]);
  const [imgList, setImgList] = useState([]);
  const [detailValue, setDetailValue] = useState(null);
  const [modalFormObj, setModalFormObj] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const [types, setTypes] = useState([]);
  const [list, setList] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);

  const start = async() => {
    setLoading(true);
    //网络请求批量修改数据
    const result = await REQUEST.post({
      url: '/zhujiajiao/v2/admin/select/listupdate',
      data: { ids: selectedRowKeys }
    });
    if (!result) return;
    if (result.ok == 0) {
      message.success('操作ok');
      setSelectedRowKeys(selectedRowKeys);
      setLoading(false);
      getList();//重新获取列表
    } else {
      message.error('操作失败');
      setLoading(false);
    }
  };
  
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const hasSelected = selectedRowKeys.length > 0;
  //关闭弹窗
  const closeOpenHandle =() =>{
    setOpen(false);
  }

  const closeModalHandle = () => {
    setImageFileList([]);
    setModalVisible(false);
    setModalFormObj(null);
    setDetailValue(null);
    setTimeout(() => {
      console.log('----,表格重置了----');
      form.resetFields();
    }, 20);
  };


  const getList = async (data = {}) => {
    const result = await REQUEST.get({
      url: '/zhujiajiao/v2/admin/select/list',
      data
    });
    if (!result) return;

    result.data.list.map(item => {
      item.key = item.id;
      return item;
    });
    // 根据isSel=1的条件默认选中行
    const defaultSelectedRowKeys = result.data.list
      .filter((item) => item.isSel === 1)
      .map((item) => item.id);

    setSelectedRowKeys(defaultSelectedRowKeys);
    setList(result.data.list);
  };

  const getTypes = async () => {
    const result = await REQUEST.get({
      url: '/zhujiajiao/v2/admin/types/list'
    });
    if (!result) return;
    const ls = transformData(result);
    setTypes(ls);
  }

  function transformData(data) {
    const parents = data.data.list.filter(item => item.pid === 0);
    return parents.map(parent => {
      const children = data.data.list.filter(item => item.pid === parent.id);
      const childrenFormatted = children.map(child => ({
        value: child.id,
        label: child.pname
      }));
      return {
        value: parent.id,
        label: parent.pname,
        children: childrenFormatted
      };
    });
  }
  useEffect(() => {
    getList();
    getTypes();//获取商户类型列表

    return () => false;
  }, [123]);

  const submitHandle = async (params = {}) => {
    if (!params) return;

    let url = '/zhujiajiao/v2/admin/select/add';
    if (modalFormObj?.id) {
      params.id = modalFormObj.id;
      url = '/zhujiajiao/v2/admin/select/update';
    }

    const result = await REQUEST.post({
      url,
      data: params
    });
    if (!result) return;

    message.success('操作成功');

    closeModalHandle();
    getList();
  };
  const deleteHandle = async (id) => {
    if (!id) return;

    const result = await REQUEST.post({
      url: '/zhujiajiao/v2/admin/select/delete',
      data: {
        id
      }
    });
    if (!result) return;

    message.success('操作成功');
    getList();
  };

  const ImageWithPreview = (props) => {
    // const [ showEye, setShowEye ] = useState(false);
    const [visible, setVisible] = useState(false);
    const { src } = props;
    return (
      <div style={{ display: 'inline-block', cursor: 'pointer', position: 'relative', width: 56, height: 56, backgroundImage: `url(${src})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }} onClick={() => setVisible(true)}>
        <ZoomInOutlined style={{ color: 'rgba(255,255,255,0.85)', fontSize: 18, position: 'absolute', zIndex: 9, right: 8, bottom: 8 }} />
        <Image
          height={56}
          style={{ display: 'none' }}
          src={src}
          preview={{
            visible,
            src,
            onVisibleChange: value => {
              setVisible(value);
            },
          }}
        />
      </div>
    )
  };
  const onChange = value => {
    // console.log(value);
  };

  return (
    <Page {...{
      ...props,
      breadcrumbs: [{ label: '首页' }, { label: '商户推荐' }],
      title: '商户推荐'
    }}>
      <section className="select-container" style={{ minHeight: window.innerHeight }}>
        <div className="select-top">
          <Button type="primary" onClick={async () => {
            setOpen(true);
            // form.resetFields();
          }}>页面精选</Button>
          <Button type="primary" onClick={async () => {
            setModalVisible(true);
            form.resetFields();
          }}>新增商户</Button>
          <FilterPanel {...{
            fields: [
              { type: 'tree-select', label: '选择分组', name: 's-id', placeholder: '请选择', options: types },
              { type: 'input', label: '标题', name: 's-company', placeholder: '请输入标题关键字' },
            ],
            filterHandle: data => {
              console.log('filterHandle--data', data);
              data.page = 0;
              getList(data);
            },
            exportFields: true,
            exportHandle:true
          }} />
        </div>
        <Table {...{
          size: 'small',
          locale: { emptyText: '暂无数据' },
          dataSource: list,
          //设置每页展示条数
          pagination: {
            pageSize: 10,
            total: list.length,
            showTotal: total => `共 ${total} 条`,
          },
          scroll: { x: 1000 },
          columns: [
            {
              title: '封面', dataIndex: 'cover', key: 'cover',
              render: (text, record, index) => <ImageWithPreview src={CONST.imgUrl + record.cover} />
            },
            {
              title: '商户名称', dataIndex: 'company', key: 'company', ellipsis: { showTitle: false },
              render: (text) => <Tooltip placement="topLeft" title={text}>{text}</Tooltip>
            },
            {
              title: '商户地址', dataIndex: 'address', key: 'address', ellipsis: { showTitle: false },
              render: (text) => <Tooltip placement="topLeft" title={text}>{text}</Tooltip>
            },
            {
              title: '商户联系方式', dataIndex: 'tel', key: 'tel', ellipsis: { showTitle: false },
              render: (text) => <Tooltip placement="topLeft" title={text}>{text}</Tooltip>
            },
            {
              title: '商户营业时间', dataIndex: 'hours', key: 'hours', ellipsis: { showTitle: false },
              render: (text) => <Tooltip placement="topLeft" title={text}>{text}</Tooltip>
            },
            {
              title: '是否上线', dataIndex: 'status', key: 'status', width: 100,
              render: (text, record, index) => {
                return <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ color: text == 1 ? '#52C41A' : 'red' }}>{CONST.introType[text]}</span>
                </div>
              }
            },
            {
              title: '操作', dataIndex: 'edit', key: 'edit', width: 156, fixed: 'right',
              render: (text, record, index) => {
                const _style = { marginRight: 10, fontSize: 12 };
                return <>
                  <Button size="small" type="primary" ghost style={_style} onClick={() => {
                    const _record = { ...record };
                    setModalFormObj(_record);
                    let result = [];
                    // 遍历较长的数组（one）
                    for (let i = 0; i < _record.onetype.length; i++) {
                      if (i < _record.twotype.length) {
                        // 如果 two 有对应元素，组成 [one[i], two[i]]
                        result.push([_record.onetype[i], _record.twotype[i]]);
                      } else {
                        // 如果 two 没有对应元素，组成 [one[i]]
                        result.push([_record.onetype[i]]);
                      }
                    }
                    _record.types = result;

                    if (_record.cover && _record.cover.length > 0) {
                      setImageFileList([_record.cover]);
                    }
                    //字符串转数组
                    if (_record.img) {
                      const imgList = _record.img.split(',');
                      setImgList(imgList);
                    }
                    form.setFieldsValue(_record);
                    setModalVisible(true);
                  }}>编辑</Button>
                  <Button type="text" danger size="small" style={_style} onClick={() => {
                    Modal.confirm({
                      title: '删除的数据将无法找回，请慎重操作！',
                      icon: <WarningOutlined style={{ color: '#E45357' }} />,
                      // content: 'Bla bla ...',
                      okText: '确认删除',
                      cancelText: '取消',
                      onOk: () => {
                        deleteHandle(record.id);
                      },
                      onCancel: () => {
                      },
                    });
                  }}>删除</Button>
                </>
              }
            },
          ]
        }} />
      </section>

      <Modal {...{
        title: modalFormObj && '编辑' || '新增',
        width: '75%',
        open: modalVisible,
        maskClosable: false,
        destroyOnClose: true,
        onCancel: closeModalHandle,
        footer: null
      }}>
        {
          modalVisible && <Form {...{
            initialValues: modalFormObj || undefined,
            form,
            labelCol: { span: 6 },
            wrapperCol: { span: 16 },
            onFinish: values => {
              console.log(values.types);
              let data = values.types;
              // 提取每个子数组的第一个元素
              const firstElements = data.map(subArray => subArray[0]);
              // [1, 2, 1, 3, 3, 14]

              // 提取每个子数组的第二个元素（过滤掉没有第二个元素的子数组）
              const secondElements = data
                .filter(subArray => subArray.length > 1)
                .map(subArray => subArray[1]);
              // [5, 10, 6, 12, 13]

              if (detailValue && detailValue.toHTML() != '<p></p>') {
                values.detail = detailValue.toHTML();
              }
              values.cover = imageFileList && imageFileList[0] || '';
              values.onetype = firstElements;
              values.twotype = secondElements;
              values.img = imgList && imgList.join(',') || '';
              submitHandle(values);
            }
          }}>
            <Form.Item
              label="封面图"
              name="cover"
              required
              rules={[
                {
                  validator: async (_, names) => {
                    if (!imageFileList || imageFileList.length <= 0) {
                      return Promise.reject(new Error('轮播图至少需要上传1张'));
                    }
                  },
                },
              ]}
            >
              <UploadPictureList {...{
                pictureLength: 1,
                multiple: true,
                action: `${CONST.uploadPrefix}/zhujiajiao/v2/admin/select/upload`,
                defaultFileList: imageFileList || [],
                changeHandle: fileList => {
                  setImageFileList(fileList);
                }
              }} />
            </Form.Item>
            <Form.Item
              label="轮播图"
              name="img"
              required
              rules={[
                {
                  validator: async (_, names) => {
                    if (!imgList || imgList.length <= 0) {
                      return Promise.reject(new Error('轮播图至少需要上传1张'));
                    }
                  },
                },
              ]}
            >
              <UploadPictureList {...{
                pictureLength: 5,
                multiple: true,
                action: `${CONST.uploadPrefix}/zhujiajiao/v2/admin/select/upload`,
                defaultFileList: imgList || [],
                changeHandle: fileList => {
                  setImgList(fileList);
                }
              }} />
            </Form.Item>

            <Form.Item label="商户类型" name="types" rules={[
              { required: true, message: '商户类型不能为空' }
            ]}>
              <Cascader multiple={true} options={types} onChange={onChange} placeholder="Please select" />
            </Form.Item>
            <Form.Item label="商户名称" name="company" rules={[
              { required: true, message: '商户名称不能为空' }
            ]}>
              <Input placeholder="请输入10字以内的商户名称" allowClear />
            </Form.Item>
            <Form.Item label="商户介绍" name="content">
              <Input.TextArea placeholder="商户介绍" allowClear />
            </Form.Item>
            <Form.Item label="商户地址" name="address" rules={[
              { required: true, message: '商户地址不能为空' }
            ]}>
              <Input placeholder="请输入10字以内的商户地址" allowClear onBlur={async (e) => {
                const address = e.currentTarget.value;
                const result = await REQUEST.get({
                  hideLoading: true,
                  url: '/zhujiajiao/v2/admin/select/address',
                  data: {
                    address
                  }
                });
                if (!result) return;
                const { lat, lng } = result?.data?.result?.location || {};
                form.setFieldsValue({ lat, lng });
              }} />
            </Form.Item>
            <Form.Item label="经度" name="lat">
              <Input placeholder="根据地址自动生成，可手动修改" allowClear />
            </Form.Item>
            <Form.Item label="纬度" name="lng">
              <Input placeholder="根据地址自动生成，可手动修改" allowClear />
            </Form.Item>
            <Form.Item label="商户营业时间" name="hours">
              <Input placeholder="请输入10字以内的商户地址" allowClear />
            </Form.Item>
            <Form.Item label="商户联系方式" name="tel" rules={[
              { required: true, message: '商户名称不能为空' }
            ]}>
              <Input placeholder="请输入10字以内的商户联系方式" allowClear />
            </Form.Item>
            <Form.Item label="状态" name="status" rules={[
              { required: true, message: '状态不能为空' }]}>
              <Select placeholder="请设置状态">
                {
                  Object.keys(CONST.introType).map((key, idx) => {
                    return (
                      <Select.Option key={idx} value={Number(key)}>{CONST.introType[key]}</Select.Option>
                    )
                  })
                }
              </Select>
            </Form.Item>
            <Form.Item label="活动排序" name="sort" extra={<><ExclamationCircleOutlined style={{ paddingRight: 4 }} /><span>越大越靠前</span></>}>
              <InputNumber placeholder="请输入排序" style={{ width: 200 }} />
            </Form.Item>

            <Form.Item label=" " colon={false}>
              <Button style={{ marginRight: 16 }} onClick={closeModalHandle}>取消</Button>
              <Button style={{ marginRight: 16 }} type="primary" htmlType="submit">提交</Button>
            </Form.Item>
          </Form>
        }
      </Modal>


      <Modal {...{
        title: '页面精选',
        width: '75%',
        open: open,
        maskClosable: false,
        destroyOnClose: true,
        onCancel: closeOpenHandle,
        footer: null
      }}>
        <div>
          <div
            style={{
              marginBottom: 16,
            }}
          >
            <Button type="primary" onClick={start} disabled={!hasSelected} loading={loading}>
              数据更新
            </Button>
            <span
              style={{
                marginLeft: 8,
              }}
            >
              {hasSelected ? `精选 ${selectedRowKeys.length} 条` : ''}
            </span>
          </div>
          <Table {...{
            size: 'small',
            locale: { emptyText: '暂无数据' },
            dataSource: list,
            //设置每页展示条数
            pagination: {
              pageSize: 10,
              total: list.length,
              showTotal: total => `共 ${total} 条`,
            },
            scroll: { x: 1000 },
            rowKey:"id",
            rowSelection:rowSelection,
            columns: [
              {
                title: '封面', dataIndex: 'cover', key: 'cover',
                render: (text, record, index) => <ImageWithPreview src={CONST.imgUrl + record.cover} />
              },
              {
                title: '商户名称', dataIndex: 'company', key: 'company', ellipsis: { showTitle: false },
                render: (text) => <Tooltip placement="topLeft" title={text}>{text}</Tooltip>
              },
              {
                title: '是否上线', dataIndex: 'status', key: 'status', width: 100,
                render: (text, record, index) => {
                  return <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ color: text == 1 ? '#52C41A' : 'red' }}>{CONST.introType[text]}</span>
                  </div>
                }
              },
            ]
          }} />
        </div>

      </Modal>

    </Page>
  );
};

export default PageModel;
